// AI generated function based on this prompt:
// I need to convert a complex JSON internal format to a simple JSON that can be read by LLMs.
// In order for meto test this transformation, can you make a HTML page with javascript, with
// two text areas, one where I paste JSON and another one that shows converted JSON. There
// should be a button between that triggers the transformation. The transformation should
// transform the first JSON to the second:
// -Get the events from the eventsJson section
// -previousEvent is always the first event in the array if there are many
// -Filter out events of type bpmn:ExclusiveGateway (only keep bpmn:Task)
// -If a parent is of type bpmn:ExclusiveGateway, look for its main parent (the first ID in the "parents" array is always the main parent) until you find one of type bpmn:Task
// -If the previous event is "start" the leave the field previousEvent empty.
// -Aggregate is the description taken from the card with the cardType with the field aggregateType set to true
// -Role comes from the lane
// -Cards are what you find under in the json object requirementJson
// -Each card has a cardType object and the card type name is found in the title field
// -Use card types use title as the key when building the transformed json, except for the special card types defined below (triggerType, aggregateType, queryType)
// -For cards of card types set as triggerType, aggregateType or queryType there is a limit of one card per event per type
// -If an event has a card where the card type has triggerType set to true use use the key causedByCommand when adding this card to the event.
// -If an event has a card where the card type has aggregateType set to true use use the key aggregate when adding this card to the event.
// -If an event has a card where the card type has queryType set to true use use the key readModel when adding this card to the event.
// -Condition is only used when an event has bpmn:ExclusiveGateway before it. Then use the description from the gateway and conditionLabels from the relevant parent.
// -Add a simple id to each event, starting from 1 and increment by 1

// First JSON before conversion:
// {
//   "id": "ebd46c2f-5c00-440a-afa1-44733f257455",
//   "projectId": "9cae4cbd-3048-412b-ba90-378caf0f9685",
//   "name": "Simple workflow",
//   "accessLevel": "PRIVATE",
//   "version": 183,
//   "lanesVersion": 7,
//   "sameAsVersion": null,
//   "status": 0,
//   "updatedAt": "2025-08-19T06:21:23.773Z",
//   "starred": null,
//   "aiDescription": "A CRM process used by Salesforce",
//   "aiVersion": 12,
//   "updateNote": {
//     "userRealName": "Staffan 123 Palopää",
//     "action": "added card",
//     "target": "Given a Lead already exists in the system with the same contact information, When the SalesRep attempts to capture a new lead with that duplicate information, Then the system should prevent the creation of a new Lead and alert the user to the existing duplicate."
//   },
//   "lanes": [
//     { "id": "278e54bb-84d0-4232-8bcb-02fe0756fb3d", "name": "SalesRep" },
//     { "id": "58d341fd-8e26-497b-b9a6-1b75ff0a3da0", "name": "Support Agent" },
//     { "id": "9569ef89-227f-481b-aed7-747f4bb4613e", "name": "Automation" }
//   ],
//   "eventDefinition": {
//     "title": "Event",
//     "description": "Something that happened, a state transition, usually the result of executing some action/command",
//     "color": {
//       "red": 255,
//       "green": 194,
//       "blue": 141,
//       "rgb": "rgb(255,194,141)"
//     }
//   },
//   "roleDefinition": {
//     "title": "Lane",
//     "description": "Lanes can be used for parallel flows, systems or actors/roles.",
//     "color": {
//       "red": 207,
//       "green": 211,
//       "blue": 217,
//       "rgb": "rgb(207,211,217)"
//     }
//   },
//   "eventsJson": [
//     {
//       "id": "66ebbd1e-d293-4a65-b514-c09f5995085c",
//       "laneId": "278e54bb-84d0-4232-8bcb-02fe0756fb3d",
//       "groupId": null,
//       "description": "Lead Captured",
//       "type": "bpmn:Task",
//       "conditionLabel": null,
//       "version": 9,
//       "conditionLabels": null,
//       "parents": ["start"],
//       "offset": 0,
//       "subprocess": null,
//       "dataModels": [
//         {
//           "name": "Lead Captured by SalesRep",
//           "type": "Event Story",
//           "cardId": "4bd339e1-ec53-4726-8b67-c54b772ea0e6",
//           "dataFields": [
//             {
//               "name": "First Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Last Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Company",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Email",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Phone Number",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Lead Source",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             }
//           ]
//         },
//         {
//           "name": "Read Model",
//           "type": "Read Model",
//           "cardId": "e822a317-4340-4ba1-b7be-1148161685b9",
//           "dataFields": [
//             {
//               "name": "Lead Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Company Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Email",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Status",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             }
//           ]
//         }
//       ],
//       "color": null,
//       "requirementsJson": [
//         {
//           "id": "4bd339e1-ec53-4726-8b67-c54b772ea0e6",
//           "description": "Capture Lead",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "n",
//           "done": false,
//           "version": 4,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "af3dbaaa-63a4-419d-a108-9ae6b656d8c2",
//           "cardType": {
//             "id": "af3dbaaa-63a4-419d-a108-9ae6b656d8c2",
//             "title": "Command",
//             "triggerType": true,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": null,
//             "color": { "red": 94, "green": 206, "blue": 248 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "634534ec-c6f5-4570-b3ea-1c9cd048b798",
//           "description": "",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "u",
//           "done": false,
//           "version": 4,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "93f8b1ed-1f78-4198-91f2-eec7c9d38f9b",
//           "cardType": {
//             "id": "93f8b1ed-1f78-4198-91f2-eec7c9d38f9b",
//             "title": "Aggregate Root",
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": true,
//             "gwtType": null,
//             "color": { "red": 249, "green": 216, "blue": 98 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": "60e6e25f-c073-48e3-806f-91ef672189e5",
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "e822a317-4340-4ba1-b7be-1148161685b9",
//           "description": "Find Duplicate Leads",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "x",
//           "done": false,
//           "version": 4,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "7cbedeb3-b3b1-4286-8e24-01f1510dccbb",
//           "cardType": {
//             "id": "7cbedeb3-b3b1-4286-8e24-01f1510dccbb",
//             "title": "Read Model",
//             "triggerType": false,
//             "queryType": true,
//             "aggregateType": null,
//             "gwtType": null,
//             "color": { "red": 100, "green": 171, "blue": 67 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "7da46652-9048-4ea3-b9b3-a4a6ad9bf2f0",
//           "description": "Given a potential customer's contact information, When the SalesRep captures the lead, Then a new Lead should be created in the system.",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "z",
//           "done": false,
//           "version": 4,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//           "cardType": {
//             "id": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//             "title": "Given-When-Then",
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": true,
//             "color": { "red": 156, "green": 43, "blue": 246 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "requirementId": "93ff5f9d-d280-4231-ab44-ab6533e67f79",
//           "requirementIndex": -1,
//           "description": "Given a Lead already exists in the system with the same contact information, When the SalesRep attempts to capture a new lead with that duplicate information, Then the system should prevent the creation of a new Lead and alert the user to the existing duplicate.",
//           "sortkey": "zzzn",
//           "cardTypeId": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//           "releaseNo": null,
//           "done": false,
//           "version": 1,
//           "eventId": "66ebbd1e-d293-4a65-b514-c09f5995085c",
//           "eventIndex": 0,
//           "boundedContext": null,
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "entityId": null,
//           "cardinality": null,
//           "id": "93ff5f9d-d280-4231-ab44-ab6533e67f79",
//           "attachments": [],
//           "comments": [],
//           "reactions": [],
//           "cardType": {
//             "id": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//             "title": "Given-When-Then",
//             "description": "An acceptance test in the Given-When-Then style for this step of the process.",
//             "color": {
//               "red": 156,
//               "green": 43,
//               "blue": 246,
//               "rgb": "rgb(156,43,246)"
//             },
//             "showInBacklog": true,
//             "generateWithAI": true,
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": true,
//             "defaultType": false,
//             "order": "e"
//           }
//         }
//       ]
//     },
//     {
//       "id": "b300737b-d1e1-45e2-91b8-4b8eb30b23cf",
//       "laneId": "278e54bb-84d0-4232-8bcb-02fe0756fb3d",
//       "groupId": null,
//       "description": "Lead Qualified",
//       "type": "bpmn:Task",
//       "conditionLabel": null,
//       "version": 11,
//       "conditionLabels": null,
//       "parents": ["66ebbd1e-d293-4a65-b514-c09f5995085c"],
//       "offset": 0,
//       "subprocess": null,
//       "dataModels": [
//         {
//           "name": "Lead Qualified by SalesRep",
//           "type": "Event Story",
//           "cardId": "a5ebe844-3989-4dce-a05f-525f48dbea3d",
//           "dataFields": [
//             {
//               "name": "Lead ID",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Qualification Status",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Qualification Notes",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Next Steps",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             }
//           ]
//         },
//         {
//           "name": "Read Model",
//           "type": "Read Model",
//           "cardId": "669b8cbb-8f81-4367-a956-eb0da6e9a930",
//           "dataFields": [
//             {
//               "name": "Lead Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Company",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Lead Source",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Interaction History",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Status",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             }
//           ]
//         }
//       ],
//       "color": null,
//       "requirementsJson": [
//         {
//           "id": "a5ebe844-3989-4dce-a05f-525f48dbea3d",
//           "description": "Qualify Lead",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zn",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "af3dbaaa-63a4-419d-a108-9ae6b656d8c2",
//           "cardType": {
//             "id": "af3dbaaa-63a4-419d-a108-9ae6b656d8c2",
//             "title": "Command",
//             "triggerType": true,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": null,
//             "color": { "red": 94, "green": 206, "blue": 248 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "5912ef2f-3a91-4df8-97f4-ee79f2b94dc7",
//           "description": "Lead",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zu",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "93f8b1ed-1f78-4198-91f2-eec7c9d38f9b",
//           "cardType": {
//             "id": "93f8b1ed-1f78-4198-91f2-eec7c9d38f9b",
//             "title": "Aggregate Root",
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": true,
//             "gwtType": null,
//             "color": { "red": 249, "green": 216, "blue": 98 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": "60e6e25f-c073-48e3-806f-91ef672189e5",
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "669b8cbb-8f81-4367-a956-eb0da6e9a930",
//           "description": "Lead Details",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zx",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "7cbedeb3-b3b1-4286-8e24-01f1510dccbb",
//           "cardType": {
//             "id": "7cbedeb3-b3b1-4286-8e24-01f1510dccbb",
//             "title": "Read Model",
//             "triggerType": false,
//             "queryType": true,
//             "aggregateType": null,
//             "gwtType": null,
//             "color": { "red": 100, "green": 171, "blue": 67 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "8e710ddf-1fe3-459e-a771-b06a7ab8e8bc",
//           "description": "Given an existing unqualified Lead, When the SalesRep qualifies the lead, Then the Lead's status should be updated to 'Qualified'.",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zz",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//           "cardType": {
//             "id": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//             "title": "Given-When-Then",
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": true,
//             "color": { "red": 156, "green": 43, "blue": 246 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         }
//       ]
//     },
//     {
//       "id": "3162e81e-c92e-48d1-9f34-7f71ce624066",
//       "laneId": "278e54bb-84d0-4232-8bcb-02fe0756fb3d",
//       "groupId": null,
//       "description": "Lead Converted",
//       "type": "bpmn:Task",
//       "conditionLabel": null,
//       "version": 10,
//       "conditionLabels": [
//         { "parentId": "aa921184-be91-4092-ae1b-4066060aa786", "name": "YES" }
//       ],
//       "parents": ["aa921184-be91-4092-ae1b-4066060aa786"],
//       "offset": 0,
//       "subprocess": null,
//       "dataModels": [
//         {
//           "name": "Lead Converted by SalesRep",
//           "type": "Event Story",
//           "cardId": "27e6fbfc-221b-4329-ada1-4d69a71fa3bc",
//           "dataFields": [
//             {
//               "name": "Lead ID",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "New Account Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "New Contact Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "New Opportunity Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Converted Status",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Owner ID",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             }
//           ]
//         },
//         {
//           "name": "Read Model",
//           "type": "Read Model",
//           "cardId": "1b15fd16-477a-44f9-813d-24e52e0da909",
//           "dataFields": [
//             {
//               "name": "Lead Name",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Company",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Owner",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             },
//             {
//               "name": "Status",
//               "cardinality": null,
//               "exampleData": null,
//               "relatedEntityId": null,
//               "type": null,
//               "tags": null,
//               "hideInForm": null,
//               "dataFields": null
//             }
//           ]
//         }
//       ],
//       "color": null,
//       "requirementsJson": [
//         {
//           "id": "27e6fbfc-221b-4329-ada1-4d69a71fa3bc",
//           "description": "Convert Lead",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zzn",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "af3dbaaa-63a4-419d-a108-9ae6b656d8c2",
//           "cardType": {
//             "id": "af3dbaaa-63a4-419d-a108-9ae6b656d8c2",
//             "title": "Command",
//             "triggerType": true,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": null,
//             "color": { "red": 94, "green": 206, "blue": 248 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "4d722342-3beb-4bf4-ad62-4e30c56bb079",
//           "description": "Lead",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zzu",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "93f8b1ed-1f78-4198-91f2-eec7c9d38f9b",
//           "cardType": {
//             "id": "93f8b1ed-1f78-4198-91f2-eec7c9d38f9b",
//             "title": "Aggregate Root",
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": true,
//             "gwtType": null,
//             "color": { "red": 249, "green": 216, "blue": 98 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": "60e6e25f-c073-48e3-806f-91ef672189e5",
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "1b15fd16-477a-44f9-813d-24e52e0da909",
//           "description": "Qualified Lead List",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zzx",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "7cbedeb3-b3b1-4286-8e24-01f1510dccbb",
//           "cardType": {
//             "id": "7cbedeb3-b3b1-4286-8e24-01f1510dccbb",
//             "title": "Read Model",
//             "triggerType": false,
//             "queryType": true,
//             "aggregateType": null,
//             "gwtType": null,
//             "color": { "red": 100, "green": 171, "blue": 67 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         },
//         {
//           "id": "5b3806b9-9df9-469c-8ed8-b1f3bd89a7db",
//           "description": "Given a qualified Lead, When the SalesRep converts the lead, Then an Account, Contact, and Opportunity should be created.",
//           "creatorId": "a94b7443-556c-4625-84e7-9343ef00113b",
//           "created": "2025-08-19T04:51:53.534Z",
//           "updated": null,
//           "releaseNo": null,
//           "sortkey": "zzz",
//           "done": false,
//           "version": 2,
//           "creator": {
//             "firstname": "Staffan 123",
//             "lastname": "Palopää",
//             "id": "a94b7443-556c-4625-84e7-9343ef00113b"
//           },
//           "attachments": [],
//           "cardTypeId": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//           "cardType": {
//             "id": "136481e0-2806-45f1-9ff6-8a391833c2e4",
//             "title": "Given-When-Then",
//             "triggerType": null,
//             "queryType": null,
//             "aggregateType": null,
//             "gwtType": true,
//             "color": { "red": 156, "green": 43, "blue": 246 }
//           },
//           "comments": [],
//           "reactions": [],
//           "assignee": null,
//           "boundedContext": null,
//           "entityId": null,
//           "cardinality": "one-to-many"
//         }
//       ]
//     },
//     {
//       "id": "aa921184-be91-4092-ae1b-4066060aa786",
//       "laneId": "278e54bb-84d0-4232-8bcb-02fe0756fb3d",
//       "groupId": null,
//       "description": "Lead Qualified",
//       "type": "bpmn:ExclusiveGateway",
//       "conditionLabel": null,
//       "version": 9,
//       "conditionLabels": null,
//       "parents": ["b300737b-d1e1-45e2-91b8-4b8eb30b23cf"],
//       "offset": 0,
//       "subprocess": null,
//       "dataModels": null,
//       "color": {
//         "red": 236,
//         "green": 192,
//         "blue": 244,
//         "rgb": "rgb(236,192,244)"
//       },
//       "requirementsJson": null
//     },
//     {
//       "id": "a304f9d2-12d9-44ae-8135-10d1886232ea",
//       "laneId": "278e54bb-84d0-4232-8bcb-02fe0756fb3d",
//       "groupId": null,
//       "description": "Lead Closed",
//       "type": "bpmn:Task",
//       "conditionLabel": null,
//       "version": 4,
//       "conditionLabels": [
//         { "parentId": "aa921184-be91-4092-ae1b-4066060aa786", "name": "NO" }
//       ],
//       "parents": ["aa921184-be91-4092-ae1b-4066060aa786"],
//       "offset": 1,
//       "subprocess": null,
//       "dataModels": null,
//       "color": {
//         "red": 255,
//         "green": 194,
//         "blue": 141,
//         "rgb": "rgb(255,194,141)"
//       },
//       "requirementsJson": null
//     }
//   ],
//   "dataModels": [
//     {
//       "id": "60e6e25f-c073-48e3-806f-91ef672189e5",
//       "name": "Lead",
//       "type": "Dimension",
//       "boundedContext": null,
//       "connectedToEvents": null,
//       "dataFields": [
//         {
//           "name": "Lead ID",
//           "exampleData": ["LD001", "LD002", "LD003"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": true,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "First Name",
//           "exampleData": ["John", "Jane", "Peter"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Last Name",
//           "exampleData": ["Smith", "Doe", "Jones"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Company",
//           "exampleData": ["ABC Corp", "XYZ Inc", "Global Tech"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Email",
//           "exampleData": [
//             "j.smith@abccorp.com",
//             "j.doe@xyz.com",
//             "p.jones@global.tech"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Status",
//           "exampleData": ["New", "Qualified", "Converted"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Lead Source",
//           "exampleData": ["Web", "Referral", "Trade Show"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Owner ID",
//           "exampleData": ["USR-001", "USR-002", "USR-001"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         }
//       ]
//     },
//     {
//       "id": "df0614f6-c85c-4e4c-9b83-e762b65ceffb",
//       "name": "Account",
//       "type": "Dimension",
//       "boundedContext": null,
//       "connectedToEvents": null,
//       "dataFields": [
//         {
//           "name": "Account ID",
//           "exampleData": ["ACCT-101", "ACCT-102", "ACCT-103"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": true,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Account Name",
//           "exampleData": ["ABC Corp", "XYZ Inc", "Global Tech"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Industry",
//           "exampleData": ["Technology", "Manufacturing", "Healthcare"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Website",
//           "exampleData": ["www.abccorp.com", "www.xyz.com", "www.global.tech"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Phone",
//           "exampleData": ["555-0101", "555-0102", "555-0103"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Billing Address",
//           "exampleData": [
//             "123 Main St, Anytown",
//             "456 Oak Ave, Sometown",
//             "789 Pine Ln, Otherville"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         }
//       ]
//     },
//     {
//       "id": "3719cdd4-0c01-44ff-ae80-60b036a8a663",
//       "name": "Contact",
//       "type": "Dimension",
//       "boundedContext": null,
//       "connectedToEvents": null,
//       "dataFields": [
//         {
//           "name": "Contact ID",
//           "exampleData": ["CON-201", "CON-202", "CON-203"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": true,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "First Name",
//           "exampleData": ["John", "Jane", "Peter"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Last Name",
//           "exampleData": ["Smith", "Doe", "Jones"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Account ID",
//           "exampleData": ["ACCT-101", "ACCT-102", "ACCT-103"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Email",
//           "exampleData": [
//             "j.smith@abccorp.com",
//             "j.doe@xyz.com",
//             "p.jones@global.tech"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Phone",
//           "exampleData": ["555-0111", "555-0122", "555-0133"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Title",
//           "exampleData": ["CEO", "VP of Sales", "IT Manager"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         }
//       ]
//     },
//     {
//       "id": "e2531366-a799-4317-928e-352fd7a7bf2e",
//       "name": "Opportunity",
//       "type": "Dimension",
//       "boundedContext": null,
//       "connectedToEvents": null,
//       "dataFields": [
//         {
//           "name": "Opportunity ID",
//           "exampleData": ["OPP-301", "OPP-302", "OPP-303"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": true,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Opportunity Name",
//           "exampleData": [
//             "ABC Corp Deal",
//             "XYZ Inc Upgrade",
//             "Global Tech Project"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Account ID",
//           "exampleData": ["ACCT-101", "ACCT-102", "ACCT-103"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Stage",
//           "exampleData": ["Negotiation", "Closed Won", "Closed Lost"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Amount",
//           "exampleData": ["50000", "75000", "25000"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Close Date",
//           "exampleData": ["2024-08-30", "2024-07-15", "2024-07-20"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Loss Reason",
//           "exampleData": ["", "", "Price"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Closing Notes",
//           "exampleData": [
//             "Final proposal sent",
//             "Contract signed",
//             "Competitor offered lower"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         }
//       ]
//     },
//     {
//       "id": "c50af71e-fc82-45ce-a594-87ad01d648f4",
//       "name": "Case",
//       "type": "Dimension",
//       "boundedContext": null,
//       "connectedToEvents": null,
//       "dataFields": [
//         {
//           "name": "Case ID",
//           "exampleData": ["CASE-001", "CASE-002", "CASE-003"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": true,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Account ID",
//           "exampleData": ["ACCT-101", "ACCT-102", "ACCT-103"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Contact ID",
//           "exampleData": ["CON-201", "CON-202", "CON-203"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Subject",
//           "exampleData": ["Billing Issue", "Product Question", "Login Problem"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Status",
//           "exampleData": ["New", "Resolved", "Closed"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Priority",
//           "exampleData": ["High", "Medium", "Low"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Owner ID",
//           "exampleData": ["USR-101", "USR-102", "USR-101"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Resolution Notes",
//           "exampleData": [
//             "",
//             "Provided user guide link",
//             "Reset password for user"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         }
//       ]
//     },
//     {
//       "id": "e84dcf8a-ac14-47a7-a143-f2d322020824",
//       "name": "User",
//       "type": "Dimension",
//       "boundedContext": null,
//       "connectedToEvents": null,
//       "dataFields": [
//         {
//           "name": "User ID",
//           "exampleData": ["USR-001", "USR-002", "USR-101"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": true,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Full Name",
//           "exampleData": ["Alice Williams", "Bob Brown", "Carol Davis"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Email",
//           "exampleData": [
//             "a.williams@company.com",
//             "b.brown@company.com",
//             "c.davis@company.com"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Role",
//           "exampleData": ["SalesRep", "SalesRep", "Support Agent"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": ["REQUIRED"],
//           "hideInForm": null
//         },
//         {
//           "name": "Availability Status",
//           "exampleData": ["Available", "On a call", "Available"],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         },
//         {
//           "name": "Skills",
//           "exampleData": [
//             "Enterprise Sales",
//             "SMB Sales",
//             "Billing; Tier 2 Support"
//           ],
//           "cardinality": "one-to-one",
//           "relatedEntityId": null,
//           "primaryKey": false,
//           "reference": null,
//           "type": null,
//           "tags": [""],
//           "hideInForm": null
//         }
//       ]
//     }
//   ],
//   "boundedContexts": null,
//   "groups": [],
//   "canAppliconExport": null,
//   "thumbnail": null
// }

// Second JSON after conversion:
// {
//   "events": [
//     {
//       "id": 1
//       "name": "Lead Captured",
//       "role": "SalesRep",
//       "previousEventId": null,
//       "readModels": [{ "name": "Find Duplicate Leads" }],
//       "causedByCommand": { "name": "Capture Lead" },
//       "aggregate": { "name": "Lead" },
//       "Given-When-Then": [
//         {
//           "name": "Given a potential customer's contact information, When the SalesRep captures the lead, Then a new Lead should be created in the system."
//         },
//         {
//           "name": "Given a Lead already exists in the system with the same contact information, When the SalesRep attempts to capture a new lead with that duplicate information, Then the system should prevent the creation of a new Lead and alert the user to the existing duplicate."
//         }
//       ]
//     },
//     {
//       "id": 2
//       "name": "Lead Qualified",
//       "role": "SalesRep",
//       "previousEventId": 1,
//       "readModels": [{ "name": "Lead Details" }],
//       "causedByCommand": { "name": "Qualify Lead" },
//       "aggregate": { "name": "Lead" },
//       "Given-When-Then": [
//         {
//           "name": "Given a potential customer's contact information, When the SalesRep captures the lead, Then a new Lead should be created in the system."
//         }
//       ],
//     },
//     {
//       "id": 3,
//       "name": "Lead Converted",
//       "role": "SalesRep",
//       "previousEventId": 2,
//       "readModels": [{ "name": "Qualified Lead List" }],
//       "causedByCommand": { "name": "Convert Lead" },
//       "aggregate": { "name": "Lead" },
//       "Given-When-Then": [
//         {
//           "name": "Given a qualified Lead, When the SalesRep converts the lead, Then an Account, Contact, and Opportunity should be created."
//         }
//       ],
//       "condition": "Lead Qualified == Yes"
//     },
//     {
//       "id": 4,
//       "name": "Lead closed",
//       "role": "SalesRep",
//       "previousEvent": 2
//       "condition": "Lead Qualified == No"
//     }
//   ]
// }

export const transformWorkflow = (src) => {
  // Guards
  if (!src) {
    throw new Error('Input does not look like the expected format')
  }

  // Index lanes (for role lookup)
  const laneById = new Map((src.lanes || []).map((l) => [l.id, l]))

  // Index events by id & separate tasks and gateways
  const events = src.eventsJson || []
  const isTask = (e) => e && e.type === 'bpmn:Task'
  const isGateway = (e) => e && e.type === 'bpmn:ExclusiveGateway'
  const eventById = new Map(events.map((e) => [e.id, e]))

  const transformDataFields = (fields) => {
    if (!Array.isArray(fields)) {
      return []
    }

    return fields
      .filter((field) => field && field.name)
      .map((field) => ({ name: field.name }))
  }

  // Helper: find the main parent chain until we hit a Task or "start"
  const findMainParentTaskId = (e) => {
    if (!e || !Array.isArray(e.parents) || e.parents.length === 0) {
      return null
    }
    let cur = e.parents[0] // first id is always the main parent (or "start")
    while (cur && cur !== 'start') {
      const node = eventById.get(cur)
      if (!node) {
        break
      }
      if (isTask(node)) {
        return node.id // stop on first task
      }
      // if gateway or other, keep walking its own main parent
      if (Array.isArray(node.parents) && node.parents.length > 0) {
        cur = node.parents[0]
      } else {
        cur = null // dead-end
      }
    }

    return cur === 'start' ? 'start' : null
  }

  // Helper: extract condition when immediate predecessor is a gateway
  const extractCondition = (e) => {
    if (!Array.isArray(e.parents) || e.parents.length === 0) {
      return null
    }
    const parentId = e.parents[0]
    const parent = eventById.get(parentId)
    if (!isGateway(parent)) {
      return null
    }
    const gatewayName = parent?.description || 'Gateway'
    // Try conditionLabels array first (preferred, with parentId match), fallback to conditionLabel
    let label = null
    if (Array.isArray(e.conditionLabels)) {
      const match = e.conditionLabels.find((cl) => cl.parentId === parentId) || e.conditionLabels[0]
      if (match && match.name) {
        label = match.name
      }
    }
    if (!label && e.conditionLabel) {
      label = e.conditionLabel
    }
    if (!label) {
      return gatewayName // minimal fallback
    }

    return `${gatewayName} == ${label}`
  }

  // Select only Task events
  const taskEvents = events.filter(isTask)

  // Build a dependency-aware order so parents appear before children
  // where the parent is a Task or "start" after collapsing gateways.
  const pending = new Set(taskEvents.map((e) => e.id))
  const ordered = [] // array of event ids

  // Quick cache of collapsed parent task id for each event
  const collapsedParent = new Map()
  for (const e of taskEvents) {
    collapsedParent.set(e.id, findMainParentTaskId(e))
  }

  // Start with roots (parent == 'start' or null)
  while (pending.size) {
    let progressed = false
    for (const id of Array.from(pending)) {
      const p = collapsedParent.get(id)
      if (p === 'start' || p == null || ordered.includes(p)) {
        ordered.push(id)
        pending.delete(id)
        progressed = true
      }
    }
    if (!progressed) {
      // Cycle or missing deps, just break ties deterministically by input order
      for (const id of Array.from(pending)) {
        ordered.push(id)
        pending.delete(id)
      }
    }
  }

  // Assign simple ids in the computed order
  const simpleId = new Map()
  ordered.forEach((id, idx) => simpleId.set(id, idx + 1))

  // Build output events, still including longId temporarily
  const outEventsWithLongId = []

  for (const id of ordered) {
    const e = eventById.get(id)
    const role = laneById.get(e.laneId)?.name || null
    const prev = collapsedParent.get(id)
    const previousEventId = prev && prev !== 'start' ? simpleId.get(prev) || null : null

    const eventDataModelsByCardId = new Map(
      (e.dataModels || []).map((dm) => [dm.cardId, dm])
    )

    // Cards come from requirementsJson
    const cards = Array.isArray(e.requirementsJson) ? e.requirementsJson : []
    const out = {
      id: simpleId.get(id),
      name: e.description || '',
      role,
      previousEventId,
      longId: e.id
    }

    // Special buckets per rules
    const readModels = [] // plural per example

    // Map of other card-type-title -> [{ name }]
    const otherBuckets = new Map()

    for (const c of cards) {
      const title = c?.cardType?.title || 'Card'
      const flags = c?.cardType || {}
      const item = { name: (c?.description ?? '').trim() }
      const matchingDataModel = eventDataModelsByCardId.get(c.id)

      if (!item.name) {
        continue
      }
      if (flags.triggerType) {
        if (!out.causedByCommand) {
          if (matchingDataModel) {
            item.dataFields = transformDataFields(matchingDataModel.dataFields)
          }
          out.causedByCommand = item // limit 1
        }
        continue
      }
      if (flags.aggregateType) {
        if (!out.aggregate) {
          out.aggregate = item // limit 1
        }
        continue
      }
      if (flags.queryType) {
        // limit 1 per event per type – but we allow multiple read models as array
        // To strictly limit to one, keep only the first
        if (readModels.length === 0) {
          if (matchingDataModel) {
            item.dataFields = transformDataFields(matchingDataModel.dataFields)
          }
          readModels.push(item)
        }
        continue
      }
      // For generic types, use card type title as key and collect many
      if (!otherBuckets.has(title)) {
        otherBuckets.set(title, [])
      }
      otherBuckets.get(title).push(item)
    }

    if (readModels.length > 0) {
      out.readModels = readModels
    }

    // Attach other buckets (e.g., "Given-When-Then")
    for (const [key, arr] of otherBuckets.entries()) {
      // If only one item and key is usually singular? Example keeps array for Given-When-Then.
      out[key] = arr
    }

    // Condition from preceding gateway (if any)
    const condition = extractCondition(e)
    if (condition) {
      out.condition = condition
    }

    outEventsWithLongId.push(out)
  }

  // Create the id map and the cleaned events array for the prompt
  const eventIdToLongIdMap = {}
  const outEvents = outEventsWithLongId.map((e) => {
    eventIdToLongIdMap[e.id] = e.longId
    const { longId, ...rest } = e
    return rest
  })

  // Entities
  const entities = (src.dataModels || [])
    .filter((model) => model && model.name && Array.isArray(model.dataFields))
    .map((model) => {
      const dataFields = model.dataFields
        .filter((field) => field && field.name)
        .map((field) => {
          return {
            name: field.name,
            isPrimaryKey: !!field.primaryKey,
            isRequired: Array.isArray(field.tags) && field.tags.includes('REQUIRED'),
            cardinality: field.cardinality || null,
            examples: field.exampleData || []
          }
        })

      return { name: model.name, dataFields }
    })

  return { events: outEvents, entities, eventIdToLongIdMap }
}
